import React, { Component } from "react";
import HeaderNav from "./common/HeaderNav";
import "./styles/Number.css";
import "./styles/Cart.css";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { Button } from "@mui/material";
import apiCall from "../utils/apiCall";
import { Table } from "./common/Table";
import { connect } from "react-redux";
import { cartInfo } from "./common/redux/actions";
import queryString from "query-string";
import { toast } from "react-toastify";

let mountLimit = 1;

const columns = [
  { id: "createdAt", label: "Order Date", minWidth: "10%" },
  { id: "number", label: "Number", minWidth: "10%" },
  { id: "orderedPrice", label: "Ordered Price", minWidth: "10%" },
  { id: "orderStatus", label: "Order Status", minWidth: "10%" },
];

class Orders extends Component {
  state = {
    ordersData: [],
    totalSize: 20,
    rowsPerPage: 20,
    filterData: {},
    getCartLimit: 20,
    allowCheckout: false,
  };

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        const { result } = await apiCall(
          "REACT_APP_GET_ORDERS",
          "POST",
          {
            getIdFromUserInfo: true,
            limit: this.state.getCartLimit || 20,
            skip: 0,
          },
          false
        );

        if (result && result["success"] && result["status"]) {
          let modifyData = await this.modifyApiData(result.status);
          console.log(modifyData);
          this.setState({
            ordersData: modifyData,
            totalSize: result.totalSize,
          });
        }
      } catch (error) {
        console.log("Orders componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    console.log("rawDataArray", rawDataArray);
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();

      if (data.orderedPrice) {
        data.orderedPrice = `₹ ${data.discountedPrice} /-`;
      }

      if (data.status === "paid" && data.buyerId === data.userId) {
        data["orderStatus"] = "Order Success";
      } else if (data.status !== "paid" && data.buyerId === data.userId) {
        data["orderStatus"] = "Order Failed";
      }

      return data;
    });
  }

  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = chnagedPage * rowsPerPage || 0;
    filterData["limit"] = rowsPerPage || 20;
    for (let i = 0; i < filterData["skip"]; i++) {
      skippedEmptyArrayOfObj.push({});
    }
    const { result } = await apiCall(
      "REACT_APP_GET_ORDERS",
      "POST",
      filterData
    );
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        ordersData: [...skippedEmptyArrayOfObj, ...modifyData],
        rowsPerPage: rowsPerPage,
        totalSize: await result.totalSize,
      });
      return true;
    }
    return false;
  };

  handleChange = async (event, state) => {
    let filterData = this.state.filterData;
    filterData[state] = event.target.value;
    this.setState({ filterData });
  };

  render() {
    return (
      <React.Fragment>
        <div id="mainNumbersContainer">
          {/* render Header Nav Bar */}
          <HeaderNav activeTabName="orders" />

          <div id="subMainContainer" style={{ flexDirection: "column" }}>
            {/* render numbers container with conditions */}
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                overflow: "hidden",
                marginTop: "45px",
                marginBottom: "45px",
              }}
            >
              {/* Background Image */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",

                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>

              {/* Gradient Overlay */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  background: "#000040",
                }}
              ></div>
              {/* Red circular accent */}
              <div
                style={{
                  position: "absolute",
                  width: "300px",
                  height: "300px",
                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                  borderRadius: "50%",
                  top: "-150px",
                  right: "-100px",
                  zIndex: 1,
                }}
              ></div>

              {/* Second red circular accent */}
              <div
                style={{
                  position: "absolute",
                  width: "150px",
                  height: "150px",
                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                  borderRadius: "50%",
                  bottom: "-70px",
                  left: "50px",
                  zIndex: 1,
                }}
              ></div>

              {/* Decorative dots */}
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  left: "20px",
                  display: "flex",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
              </div>

              {/* Decorative triangle */}
              <div
                style={{
                  position: "absolute",
                  bottom: "15px",
                  right: "60px",
                  width: 0,
                  height: 0,
                  borderLeft: "15px solid transparent",
                  borderRight: "15px solid transparent",
                  borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
                  transform: "rotate(45deg)",
                }}
              ></div>

              {/* Content Container */}
              <div
                style={{
                  position: "relative",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0 20px",
                  zIndex: "2",
                }}
              >
                <h1
                  style={{
                    color: "white",
                    fontSize: "42px",
                    fontWeight: "800",
                    marginBottom: "16px",
                    textAlign: "center",
                    textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
                  }}
                >
                  Order Details
                </h1>

                <p
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "400",
                    maxWidth: "700px",
                    textAlign: "center",
                    textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
                  }}
                >
                  Manage and Track your orders here.
                </p>

                {/* Decorative Line */}
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background:
                      "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
                    marginTop: "20px",
                    borderRadius: "2px",
                  }}
                ></div>
              </div>
            </div>
            <div id="CartSubContainer">
              <div className="cartContentArea">
                <div className="cartTable">
                  <Table
                    maxHeight={"fit-content"}
                    columns={columns || []}
                    dataValues={this.state.ordersData || []}
                    totalSize={this.state.totalSize || 0}
                    filterHeight={0}
                    rowsPerPage={this.state.rowsPerPage}
                    handleChangePage={this.handleChangePage}
                    emptyMessage={"No Orders Found"}
                  />
                </div>
                <div className="cartFooter">
                  <Link to={"/numbers"} style={{ textDecoration: "none" }}>
                    <Button id="cartFooterButton" variant="contained">
                      Buy More Numbers
                    </Button>
                  </Link>
                  <Link to={"/home"} style={{ textDecoration: "none" }}>
                    <Button id="cartFooterButton" variant="contained">
                      Home
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { cartInfo })(Orders);
